import {Component, Input, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {ParticleService} from '@core/services/particle.service';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {CommandService} from '@core/services/command.service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {TreatyRateCellComponent} from "../cell-components/rate-cell-components/treaty-rate-cell/treaty-rate-cell.component";
import {Country} from "../../models/treaty.models";
import {Configuration} from "@shared/models/configuration";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
    standalone: false,
    selector: 'particle-withholding-tax-rates',
  templateUrl: './withholding-tax-rates.component.html',
  styleUrls: ['./withholding-tax-rates.component.scss']
})
export class WithholdingTaxRatesComponent implements OnInit {
  sourceKey: string;
  unSubscribe$ = new Subject<void>();
  invalidateSubject: InvalidateSubject = new InvalidateSubject();
  @Input() info: {country1: Country , country2: Country};
  @Input() countryCode1: string;
  @Input() countryCode2: string;
  inputForm: FormGroup;
  availablePeriods: number[] = [];
  availablePercentage: number[] = [];

  constructor(private particleService: ParticleService,
              private router: Router,
              private particleStore: Store<ParticleState>,
              private commandService: CommandService,
              private fuseSplashScreenService: FuseSplashScreenService,
              iconRegistry: MatIconRegistry,
              sanitizer: DomSanitizer, private formBuilder: FormBuilder) {
    iconRegistry.addSvgIcon('edit-icon', sanitizer.bypassSecurityTrustResourceUrl('http://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/icons/svgs/edit-icon.svg'));
    this.particleService.registerCellComponent('TreatyRateCellComponent', TreatyRateCellComponent);
    // this.particleService.registerCellComponent('TreatyCbcReportsCellComponentComponent', TreatyCbcReportsCellComponentComponent);
    this.sourceKey = 'Treaty-Withholding-Tax-Rates';
    this.inputForm =  this.formBuilder.group({
      holdingPercentage: [100, Validators.required],
      holdingPeriod: [24, Validators.required]
    });

    for(var i = 1; i <= 24; i++) {
      this.availablePeriods = [...this.availablePeriods, i];
    }
    for(var i = 1; i <= 100; i++) {
      this.availablePercentage = [...this.availablePercentage, i];
    }
  }

  ngOnInit() {

    const infoes = this.info;
    const config = Configuration.getSmartGridConfig(this.sourceKey);
    config.Parameters['COUNTRY_CODE1'] = this.countryCode1;
    config.Parameters['COUNTRY_CODE2'] = this.countryCode2;
    config.Parameters['OWNERSHIP'] = 100;
    config.Parameters['PERIOD'] = 24;


    this.inputForm.valueChanges.subscribe(() => {
      config.Parameters['OWNERSHIP'] = this.inputForm.controls['holdingPercentage'].value;
      config.Parameters['PERIOD'] = this.inputForm.controls['holdingPeriod'].value;
      this.invalidateSubject.invalidate();
    })
  }

  goWhtMinimizer() {
  }

  goTransactionCalculator() {
  }

  onGridCellValueChange($event: any) {

  }
}
